import { LitElement, html } from 'lit-element';
import { classMap } from 'lit-html/directives/class-map.js';


export const renderSpan = (span) => html`<span class="${span.class || ''}">
${span.text}
</span>`
